import { from, of } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { dfimAxios } from '../config/Axios';
import {
  PASSWORD_RESET_REQUEST,
  PASSWORD_RESET,
  GRANT_PASSWORD_RESET_PRIVILEGE,
  passwordResetRequestSuccess,
  passwordResetRequestError,
  grantPasswordResetPrivilegeSuccess,
  grantPasswordResetPrivilegeError,
  passwordResetSuccess,
  passwordResetError,
} from '../actions/PasswordReset';

const requestPasswordReset = (email) =>
  dfimAxios
    .post('/api/password/reset', email, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data);

const grantPasswordResetPrivilege = (credentials) =>
  dfimAxios
    .get(`/api/password/reset/${credentials._id}/${credentials._jwt}`)
    .then((response) => response.data);

const resetPassword = (input) =>
  dfimAxios
    .post('/api/password/update', input, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data);

export const requestPasswordResetEpic = (action$) =>
  action$.pipe(
    ofType(PASSWORD_RESET_REQUEST),
    switchMap((action) =>
      from(requestPasswordReset(action.payload)).pipe(
        map((data) => passwordResetRequestSuccess(data)),
        catchError((error) => of(passwordResetRequestError(error)))
      )
    )
  );

export const grantPasswordResetPrivilegeEpic = (action$) =>
  action$.pipe(
    ofType(GRANT_PASSWORD_RESET_PRIVILEGE),
    switchMap((action) =>
      from(grantPasswordResetPrivilege(action.payload)).pipe(
        map((data) => grantPasswordResetPrivilegeSuccess(data)),
        catchError((error) => of(grantPasswordResetPrivilegeError(error)))
      )
    )
  );

export const resetPasswordEpic = (action$) =>
  action$.pipe(
    ofType(PASSWORD_RESET),
    switchMap((action) =>
      from(resetPassword(action.payload)).pipe(
        map((data) => passwordResetSuccess(data)),
        catchError((error) => of(passwordResetError(error)))
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [requestPasswordResetEpic, resetPasswordEpic, grantPasswordResetPrivilegeEpic];
